import {get} from 'lodash'

const getStrapiPageMeta = (strapiPageMeta) => {
    return strapiPageMeta
        ? {
              title: strapiPageMeta.title,
              description: strapiPageMeta.description,
              imagePath: get(strapiPageMeta, 'facebook_image.publicURL', undefined),
          }
        : {}
}

export default getStrapiPageMeta
